import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHeartCircleStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconHeartCircleStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.088 15.088a7.5 7.5 0 1 1 .84-2.538A6 6 0 0 0 7.45 4.073a7.5 7.5 0 0 0-2.539.84 7.5 7.5 0 1 1 10.176 10.175M8.5 17.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12M6.344 9.819a1.1 1.1 0 0 0-.28.215c-.368.37-.39.644-.318.953.102.43.434.983.992 1.597.537.59 1.174 1.12 1.694 1.51l.068.05.067-.05c.52-.39 1.158-.92 1.694-1.51.559-.614.891-1.167.992-1.597.073-.309.05-.584-.318-.953a1.1 1.1 0 0 0-.279-.215.2.2 0 0 0-.086-.028c-.02-.001-.097 0-.248.09-.153.09-.306.226-.431.362a2 2 0 0 0-.158.189v.001a1.5 1.5 0 0 1-2.466 0l-.001-.002.001.002v-.001l-.026-.034a2 2 0 0 0-.132-.155 2 2 0 0 0-.431-.363c-.152-.089-.228-.09-.248-.089a.2.2 0 0 0-.086.028m3.267-1.26C8.938 8.936 8.5 9.58 8.5 9.58s-.438-.643-1.111-1.02c-.64-.358-1.492-.478-2.385.415-2.996 2.995 3.496 6.99 3.496 6.99s6.492-3.995 3.496-6.991c-.893-.893-1.745-.773-2.385-.415"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHeartCircleStack20);
